import { plural } from '@/lib/plural';
const pad = (n) => String(n).padStart(2, '0');
/** How often an interval job runs, in the unit it has it in; null for a job run at a time of day. */
export function intervalOf(job) {
    if (job.interval_seconds != null)
        return { value: job.interval_seconds, unit: 'sec' };
    if (job.interval_minutes != null)
        return { value: job.interval_minutes, unit: 'min' };
    return null;
}
/** «Ежедневно в 03:00», «Каждые 15 мин» or «Каждые 30 сек» — how often a job runs. */
export function scheduleText(job) {
    const every = intervalOf(job);
    if (every) {
        const { value, unit } = every;
        if (value === 1)
            return unit === 'sec' ? 'Каждую секунду' : 'Каждую минуту';
        return `${plural(value, 'Каждую', 'Каждые', 'Каждые')} ${value} ${unit === 'sec' ? 'сек' : 'мин'}`;
    }
    if (job.run_hour != null && job.run_minute != null) {
        return `Ежедневно в ${pad(job.run_hour)}:${pad(job.run_minute)}`;
    }
    return job.trigger_type;
}
/** The job's schedule as it is now — PUT gets it whole, even for a bare on/off. */
export function currentSchedule(job) {
    const every = intervalOf(job);
    if (every?.unit === 'sec')
        return { interval_seconds: every.value };
    if (every)
        return { interval_minutes: every.value };
    return { run_hour: job.run_hour, run_minute: job.run_minute };
}
/**
 * The PUT for a new interval, or null when nothing changed. A job has exactly
 * one of the two intervals, so the other one always goes out cleared.
 */
export function intervalChange(job, next, enabled) {
    const now = intervalOf(job);
    if (now?.unit === next.unit && now.value === next.value && enabled === job.enabled)
        return null;
    return next.unit === 'sec'
        ? { interval_seconds: next.value, interval_minutes: null, enabled }
        : { interval_minutes: next.value, interval_seconds: null, enabled };
}
